module.exports = __webpack_public_path__ + "792b0afd329dc0d0f66699f6c654e527.svg";